import React, {useContext} from 'react'
import RolesHead from "./RolesHead"
import RolesBody from "./RolesBody"
import {Spin} from "antd"
import {SettingRoleContext} from "../../context/SettingRoleContext";

function RolesTable() {
    const SettingRolePageContext = useContext(SettingRoleContext)
    const {listRoles, loading} = SettingRolePageContext

    return <div className="LeadTable">
        <Spin spinning={loading} tip="Đang lấy dữ liệu...">
            <table className="table">
                <RolesHead/>
                <RolesBody loading={loading} listRoles={listRoles}/>
            </table>
        </Spin>
    </div>
}

export default RolesTable
